import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { htmlLang } from "@/i18n";

interface TimezoneClockProps {
  timeZone: string;
  locale?: string;
}

export default function TimezoneClock({
  timeZone,
  locale,
}: TimezoneClockProps) {
  const [time, setTime] = useState("");
  const { t, i18n } = useTranslation();
  const resolvedLocale = locale ?? htmlLang(i18n.language);

  useEffect(() => {
    const updateTime = () => {
      const formatter = new Intl.DateTimeFormat(resolvedLocale, {
        hour: "2-digit",
        minute: "2-digit",
        timeZone,
        hour12: false,
      });

      setTime(formatter.format(new Date()));
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, [timeZone, resolvedLocale]);

  return (
    <p className="text-white/60 dark:text-[#737373]">
      {t("timezoneClock.label")} - {time}
    </p>
  );
}
